import React, {useEffect, createRef, useState} from 'react';
import { SearchFieldContainer, SearchFieldLabel, SearchFieldContent, SearchFieldField, SearchFieldData, SearchFieldSelectOption, SearchFieldErrorMessage, SearchFieldSubCategorySelectOption } from './styles';

const SearchFieldCategories = ({ label, show, searchInList, error, placeholder, name, id, register, defaultValue, list, selectField, disabled,list2,subcategory1,subcategory2 }) => {
  const ref = createRef();
  const [isMenuOpen, setIsMenuOpen] = useState(show);
  const checkIfClickedOutside = e => {
    if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
      setIsMenuOpen(false);
    }
  }
  function agregarEvento(){
    document.addEventListener("mousedown", checkIfClickedOutside)
  }
  useEffect(() => {
    agregarEvento();
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [isMenuOpen, show])
  return (
    <SearchFieldContainer id="search-field"  ref={ref} onBlur={agregarEvento()}>
      <SearchFieldLabel>{label}</SearchFieldLabel>
      <SearchFieldContent>
        <SearchFieldField type="text" autoComplete="off" disabled={disabled ? true : false} placeholder={placeholder} defaultValue={defaultValue} name={name} id={id} className={error && 'error'} ref={register} onChange={e => {searchInList(e);setIsMenuOpen(true);}} onClick={e => {searchInList(e);setIsMenuOpen(true);}} />
        <SearchFieldData open={show && isMenuOpen}>
        <SearchFieldSubCategorySelectOption >{subcategory1}</SearchFieldSubCategorySelectOption>
          {list.map((item, key) => (
            <SearchFieldSelectOption tabIndex={99} key={key} onClick={(e) => selectField(item, name)}>{item.nombre}</SearchFieldSelectOption>
          ))}
          <hr></hr>
          <SearchFieldSubCategorySelectOption >{subcategory2}</SearchFieldSubCategorySelectOption>
          {list2.map((item, key) => (
            <SearchFieldSelectOption tabIndex={99} key={key} onClick={(e) => selectField(item, name)}>{item.nombre}</SearchFieldSelectOption>
          ))}
        </SearchFieldData>
        {error && <SearchFieldErrorMessage error={error}>{error.message}</SearchFieldErrorMessage>}
      </SearchFieldContent>
    </SearchFieldContainer>
  )
}

export default SearchFieldCategories
